import { useEffect } from 'react';
import { useDocReader, useDocReaderDispatch } from '../store/docReaderContext';
type Dest = [{ num: number; gen: number }];
export type PdfOutline = {
    title: string;
    items: Outlines;
    pageNum: number;
    dest?: Dest;
    count?: number;
};
export type Outlines = PdfOutline[];

// 获取PDF outline
export default function useUpdateDocReaderOutline() {
    const [state] = useDocReader();
    const dispatch = useDocReaderDispatch();
    // 预处理目录对象
    async function outlinesPretreatment(outlines: Outlines) {
        const { pdf } = state;
        if (!pdf || !outlines) {
            return;
        }
        // 使用pdf.getPageIndex方法将outline的dest转换为页码
        for (const outline of outlines) {
            const index = await pdf.getPageIndex(outline.dest?.[0]);
            outline.pageNum = index + 1;
            if (outline.items?.length > 0) {
                await outlinesPretreatment(outline.items);
            }
        }
    }
    useEffect(() => {
        const { pdf } = state;
        if (!pdf) {
            return;
        }
        pdf.getOutline?.().then(async (outlines: Outlines) => {
            await outlinesPretreatment(outlines);
            dispatch({ type: 'updatePdfOutlines', pdfOutlines: outlines || [] });
        });
    }, [state.pdf]);
}
